export default __webpack_public_path__ + "static/tag-dont-5-light-5c6e14bfdfa95a9ee1588ad8d60e7bdb00a833cb635848c73866ca811a88c8ff.png";